/* eslint-disable */
import React, { Component } from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import axios from 'axios';
import config from '../../config';
import "./ReportingDashboard.css";
import ReportingComputation from "./ReportingComputation";
const iconBasePath = "/images/";

const reportIcons = {
    // --- Environment ---
    "Energy Management": iconBasePath + "IC_energy management.svg",
    "Water Management": iconBasePath + "IC_water management.svg",
    "Non-GHG Emission": iconBasePath + "IC_non-ghg emission.svg",
    "GHG Emission": iconBasePath + "IC_GHG enission.svg",
    "Waste Management": iconBasePath + "IC_waste management.svg",
    "Biodiversity": iconBasePath + "IC_biodiversity.svg",

    // --------- Social ---------
    "Employee Diversity": iconBasePath + "IC_employee diversity.svg",
    "Employee Well-being": iconBasePath + "IC_wellbeing.svg",
    "Employee Development": iconBasePath + "IC_development.svg",
    "Employee Health and Safety": iconBasePath + "IC_health & safety.svg",
    "Employee Human Rights": iconBasePath + "IC_human rights.svg",
    "Community": iconBasePath + "IC_community.svg",
    "Consumers": iconBasePath + "IC_consumers.svg",
    "Value Chain Partners": iconBasePath + "IC_value chain.svg",


    // --- Governance ---
    "Training": iconBasePath + "IC_training.svg",
    "Sustainability: Financial": iconBasePath + "IC_financial.svg",
    "Sustainability: Sourcing": iconBasePath + "IC_sourcing.svg",
    "Sustainability: Circular Economy": iconBasePath + "IC_circular economy.svg",
    "Legal": iconBasePath + "IC_legal.svg",
    "CSR": iconBasePath + "IC_CSR.svg",

    // fallback icon
    "default": iconBasePath + "IC_energy management.svg",
};


class ReportingDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            framework: 'BRSR',
            domain: 'Environment',
            year: 'FY 2024-2025',
            reports: [],
            error: '',
        };
    }

    componentDidMount() {
        this.fetchReports();
    }

    fetchReports = () => {
        const { framework, domain, year } = this.state;
        if (!framework || !domain || !year) return;

        this.setState({ loading: true, error: '', reports: [] });

        axios.get(`${config.laravelBaseUrl}reporting-dashboard`, {
            headers: {
                authorization: "Bearer " + sessionStorage.getItem("userToken"),
            },
            params: {
                framework,
                domain,
                financial_year: year,
            },
        })
            .then((res) => {
                if (res.data?.data) {
                    this.setState({ reports: res.data.data });
                } else {
                    this.setState({ reports: [] });
                }
            })
            .catch((error) => {
                console.error("Error fetching reports:", error);
                this.setState({ error: "Failed to fetch reports." });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }, this.fetchReports);
    };

    truncateParams = (params, limit = 2) => {
        if (!Array.isArray(params) || params.length === 0) return "—";

        if (params.length <= limit) return params.join(", ");

        const visible = params.slice(0, limit).join(", ");
        return `${visible} ...`;
    };

    isNarrativeFlag = (flags) => {
        return Array.isArray(flags) && flags.includes("narrative");
    };


    renderReportCards = () => {
        const { reports, loading, error } = this.state;

        // Loading State — same as in ReportingDetails
        if (loading) {
            return (
                <div className="text-center mt-5 w-100">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-2 text-muted">Loading reports...</p>
                </div>
            );
        }

        // Error State
        if (error) {
            return (
                <div className="alert alert-danger text-center shadow-sm w-100">
                    {error}
                </div>
            );
        }

        // Empty State
        if (!reports.length) {
            return (
                <div className="alert alert-light text-center shadow-sm w-100">
                    No reports available for selection.
                </div>
            );
        }

        // 🔹 Render Report Cards
        return reports.map((report) => (
            <div key={report.id} className="col-12 col-sm-6 col-md-4 col-lg-4 mb-4">
                <div className="card report-card h-100 border-success shadow-sm">
                    <div className="card-header d-flex justify-content-between align-items-center bg-light">
                        <h6 className="mb-0 d-flex align-items-center">
                            <div className="icon-circle text-white mr-2">
                                <div className="icon-circle">
                                    <img
                                        src={reportIcons[report.card_title] || reportIcons["default"]}
                                        alt=""
                                        className="report-header-icon"
                                    />
                                </div>
                            </div>
                            {report.card_title}
                        </h6>
                        <span className="badge badge-success">Active</span>
                    </div>

                    <div className="card-body small">
                        <p>
                            <strong>Description:</strong>{" "}
                            {report.card_description || "—"}
                        </p>

                        <p>
                            <strong>Parameters:</strong>{" "}
                            {this.truncateParams(report.parameters, 10)}
                        </p>

                        <p>
                            <strong>Operating Units:</strong>{" "}
                            {Array.isArray(report.operating_units)
                                ? report.operating_units.length > 4
                                    ? `${report.operating_units.slice(0, 4).join(", ")} (+${report.operating_units.length - 4} more)`
                                    : report.operating_units.join(", ")
                                : report.operating_units || "—"}
                        </p>

                        <p>
                            <strong>Reporting Boundary:</strong>{" "}
                            {report.reporting_boundary || report.financial_year || "—"}
                        </p>

                        <p>
                            <strong>Reference:</strong>{" "}
                            {report.reference || "—"}
                        </p>
                    </div>


                    <div className="card-footer d-flex justify-content-between align-items-center">
                        <Link
                            to={`/reporting/details/${report.id}`}
                            className="btn btn-outline-info btn-sm"
                        >
                            <i className="fas fa-info-circle"></i> Details
                        </Link>

                        {/* ANALYSIS button */}
                        {this.isNarrativeFlag(report.data_flag) ? (
                            <button className="btn btn-outline-primary btn-sm" disabled>
                                <i className="fas fa-chart-line"></i> Analysis
                            </button>
                        ) : (
                            <Link
                                to={`/reporting/analysis/${report.id}`}
                                className="btn btn-outline-primary btn-sm"
                            >
                                <i className="fas fa-chart-line"></i> Analysis
                            </Link>
                        )}

                        {/* COMPUTE button */}
                        {this.isNarrativeFlag(report.data_flag) ? (
                            <button className="btn btn-outline-warning btn-sm" disabled>
                                <i className="fas fa-cogs"></i> Compute
                            </button>
                        ) : (
                            <Link
                                to={`/reporting/computation/${report.id}`}
                                className="btn btn-outline-warning btn-sm"
                            >
                                <i className="fas fa-cogs"></i> Compute
                            </Link>
                        )}
                        <Link
                            to={`/reporting/generation/${report.id}`}
                            className="btn btn-outline-success btn-sm"
                        >
                            <i className="fas fa-file-export"></i> Generate
                        </Link>
                    </div>

                </div>
            </div>
        ));
    };


    render() {
        const { framework, domain, year } = this.state;

        const frameworks = ["BRSR", "GRI"];
        const domains = ["Environment", "Social", "Governance"];
        const years = ["FY 2023-2024", "FY 2024-2025"];

        return (
            <>
                <DashboardHeader />

                <div id="wrapper">
                    <DashboardSidebar />

                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item active">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">Reporting</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <p className="heading mb-0">Reporting Dashboard</p>
                                    <button className="btn btn-primary refresh-btn" onClick={this.fetchReports}>
                                        <i className="fas fa-sync-alt"></i> Refresh Data
                                    </button>
                                </div>

                                {/* 🔹 Filters Row (restored horizontal alignment) */}
                                <div className="filters-section d-flex align-items-center mb-4">
                                    <select
                                        className="form-control mr-3"
                                        name="framework"
                                        value={framework}
                                        onChange={this.handleChange}
                                        style={{ width: '-webkit-fill-available' }}
                                    >
                                        <option value="">Select Framework</option>
                                        {frameworks.map((f) => (
                                            <option key={f} value={f}>{f}</option>
                                        ))}
                                    </select>

                                    <select
                                        className="form-control mr-3"
                                        name="domain"
                                        value={domain}
                                        onChange={this.handleChange}
                                        style={{ width: '-webkit-fill-available' }}
                                    >
                                        <option value="">Select Domain</option>
                                        {domains.map((d) => (
                                            <option key={d} value={d}>{d}</option>
                                        ))}
                                    </select>

                                    <select
                                        className="form-control mr-3"
                                        name="year"
                                        value={year}
                                        onChange={this.handleChange}
                                        style={{ width: '-webkit-fill-available' }}
                                    >
                                        <option value="">Select Year</option>
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="row report-cards-container mb-5">
                                    {this.renderReportCards()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponent />

                {/* Nested routes for reporting subpages */}
                <Switch>
                    <Route path="/reporting/details/:id" exact component={() => <div className="p-4">Report Details Page</div>} />
                    <Route path="/reporting/analysis/:id" exact component={() => <div className="p-4">Report Analysis Page</div>} />
                    <Route path="/reporting/generation/:id" exact component={() => <div className="p-4">Report Generation Page</div>} />
                    <Route path="/reporting/computation/:id" exact component={ReportingComputation} />
                </Switch>
            </>
        );
    }
}

export default ReportingDashboard;
